import { deleteDoc, doc } from "firebase/firestore";
import { deleteObject, ref } from "firebase/storage";
import React from "react";
import { toast } from "react-toastify";
import { db, storage } from "../firebase-config";

function DeleteProject({ id, imageUrl }) {
  const handleClick = async() => {
    try {
        await deleteDoc(doc(db, "blog", id))
        toast("Blog deleted successfully", {type: "success"})
        const storageRef = ref(storage, imageUrl)
        await deleteObject(storageRef)
    } catch (error) {
        toast("Error deleting blog", {type: "error"})
        console.log(error)
    }
  };
  return (
    <div>
      <button onClick={handleClick}>Delete</button>
    </div>
  );
}

export default DeleteProject;
